export const ArrorwBottom = ({
  strokeColor = "var(--color-icon-bright)",
  _className = "",
  ...props
}: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <g id="vuesax/linear/arrow-right">
      <g id="arrow-right">
        <path
          id="Vector"
          className={_className}
          d="M2.72003 5.94043L7.0667 10.2871C7.58003 10.8004 8.42003 10.8004 8.93336 10.2871L13.28 5.94043"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
